<template>
    <div class="row mb-4">
        <div class="col-md-4 mb-4">
            <label class="form-label" for="parent">Parent</label>
            <select class="form-select" id="parent" v-model="filters.parent">
                <option value="">All</option>
                <option value="none">None</option>
                <template v-for="parent in parents">
                    <option value="" disabled>---</option>
                    <option :value="parent.iplicit_id" v-text="parent.name"></option>
                    <option v-for="child in parent.children" :value="child.iplicit_id" v-text="`- ${child.name}`"></option>
                </template>
            </select>
        </div>
        <div class="col-md-4 mb-4">
            <label class="form-label" for="is_cinolla">In Cinolla</label>
            <select class="form-select" id="is_cinolla" v-model="filters.is_cinolla">
                <option value="">All</option>
                <option value="0">No</option>
                <option value="1">Yes</option>
            </select>
        </div>
        <div class="col-md-4 mb-4">
            <label class="form-label" for="is_enabled">Enabled</label>
            <select class="form-select" id="is_enabled" v-model="filters.is_enabled">
                <option value="">All</option>
                <option value="0">No</option>
                <option value="1">Yes</option>
            </select>
        </div>
    </div>

    <div class="row mb-4">
        <div class="col-md-2">
            <select class="form-select" v-model="limit">
                <option>25</option>
                <option>50</option>
                <option>100</option>
            </select>
        </div>
        <div class="col-md-4 ms-auto">
            <div class="input-group">
                <input type="text" class="form-control" v-model="searchTerm" placeholder="Search centre name or code...">
                <span class="input-group-text bg-body border-0">
                    <i class="fa fa-search"></i>
                </span>
            </div>
        </div>
    </div>

    <datatable :url="ajaxUrl" :limit="limit" :orderBy="orderBy" :orderAsc="orderAsc" :search="searchTerm" :filters="filters">
        <template #headings>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="name">Name</sortableTh>
            <th>Parent</th>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="code">Code</sortableTh>
            <th>Cinolla</th>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="enabled">Enabled</sortableTh>
            <th>Sync Issues</th>
            <sortableTh v-on:set-order-by="setOrder" :currentOrderBy="orderBy" :orderAsc="orderAsc" orderBy="created_at">Created at</sortableTh>
            <th></th>
        </template>
        <template #rows="{data}">
            <tr v-for="centre in data" :key="centre.id">
                <td>{{ centre.name }}</td>
                <td>{{ centre.parent }}</td>
                <td>{{ centre.code }}</td>
                <td>
                    <i v-if="centre.cinolla" class="fa fa-check text-success"></i>
                </td>
                <td>
                    <i v-if="centre.enabled" class="fa fa-check text-success"></i>
                    <i v-else class="fa fa-times text-danger"></i>
                </td>
                <td>
                    <span :class="{'text-danger': centre.sync_logs_count > 0}">
                        {{ centre.sync_logs_count }}
                    </span>
                </td>
                <td>{{ centre.created_at }}</td>
                <td v-html="centre.actions"></td>
            </tr>
        </template>
    </datatable>

    <a :href="props.syncUrl" class="btn btn-sm btn-info">
        <i class="fa fa-fw fa-cloud-arrow-down"></i>
        Sync From Iplicit
    </a>
</template>

<script setup>
import datatable from '@/components/datatable.vue';
import sortableTh from '@/components/datatable/sortableTh.vue';
import { reactive, ref } from "vue";

const props = defineProps({
    ajaxUrl: String,
    parents: Object,
    syncUrl: String,
});

const orderBy = ref('name');
const orderAsc = ref(true);
const limit = ref(25);
const searchTerm = ref(null);
const filters = reactive({
    parent: '',
    is_cinolla: 1,
    is_enabled: '',
});

const setOrder = function (input) {
    if (orderBy.value == input) {
        orderAsc.value = ! orderAsc.value;
    } else {
        orderBy.value = input;
        orderAsc.value = true;
    }
};
</script>
